<div class="dialog-container">

  <!-- Header -->
  <div class="dialog-header">
    <span class="dialog-title">Sugestão de Agrupamento</span>
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Config bar -->
  <div class="config-bar">
    <mat-form-field appearance="outline" class="input-tg janela-field"
      [matTooltip]="agruparPorVoo ? 'Janela de tempo ignorada devido ao agrupamento por voo' : ''">
      <mat-label>Janela de tempo (min)</mat-label>
      <input matInput type="number" [(ngModel)]="janelaMinutos" step="15"
        [disabled]="agruparPorVoo" />
    </mat-form-field>

    <div class="agrupamento-flags">
      <mat-checkbox [(ngModel)]="agruparPorOrigem">Origem</mat-checkbox>
      <mat-checkbox [(ngModel)]="agruparPorDestino">Destino</mat-checkbox>
      <mat-checkbox [(ngModel)]="agruparPorVoo">Voo</mat-checkbox>
    </div>

    <button mat-button class="btn-tg" (click)="gerar()" [disabled]="loading">
      <mat-icon>auto_awesome</mat-icon>
      @if (loading && state === 'idle') { Gerando... } @else { Gerar Sugestão }
    </button>

    @if (state === 'generated') {
      <button mat-button class="btn-tg btn-confirm" (click)="confirmar()" [disabled]="loading">
        <mat-icon>check_circle</mat-icon>
        Confirmar Agrupamento
      </button>
    }
    @if (state === 'review') {
      <button mat-button class="btn-tg btn-confirm" (click)="concluir()">
        <mat-icon>done_all</mat-icon>
        Concluir
      </button>
    }
  </div>

  @if (loading) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  <!-- Idle state -->
  @if (state === 'idle' && !loading) {
    <div class="idle-state">
      <mat-icon class="idle-icon">group_work</mat-icon>
      <p>Configure a janela de tempo e clique em "Gerar Sugestão" para iniciar.</p>
    </div>
  }

  <!-- Review state -->
  @if (state === 'review') {
    <div class="review-container">
      <div class="review-heading">
        <mat-icon class="review-icon">tune</mat-icon>
        <div>
          <span class="review-title">Revisão de Valores</span>
          <span class="review-sub">Grupos duplicados podem ter os valores ajustados antes de concluir.</span>
        </div>
      </div>

      <div class="review-list">
        @for (grupo of confirmedGroups; track grupo.itemContratoId) {
          <div class="review-card" [ngClass]="{ 'review-card-duplicado': grupo.isDuplicado }">
            <div class="review-card-info">
              <span class="review-veiculo">{{ grupo.tipoVeiculoDescricao }}</span>
              @if (grupo.isDuplicado) {
                <span class="badge-duplicado" [matTooltip]="'Baseado no item #' + grupo.itemPropostaOriginalId">duplicado</span>
              }
              <span class="review-pax">{{ grupo.totalPassageiros }} PAX</span>
            </div>
            @if (grupo.isDuplicado) {
              <button mat-button class="btn-tg" [disabled]="loading" (click)="editGrupo(grupo)">
                <mat-icon>edit</mat-icon>
                Ajustar Valores
              </button>
            }
          </div>
        }
      </div>

      <!-- Coordenadores esquecidos -->
      @if (necessidadeCoordenadores?.necessitaCoordenador) {
        <div class="coordenadores-section coordenadores-section-review">
          <div class="section-heading">
            <mat-icon>manage_accounts</mat-icon>
            <span>Coordenadores</span>
            <span class="section-heading-spacer"></span>
            <button mat-button class="btn-tg btn-confirm"
              [disabled]="salvandoCoordenadores"
              (click)="salvarCoordenadores()">
              <mat-icon>save</mat-icon>
              Salvar Coordenadores
            </button>
          </div>
          <p class="coordenadores-hint">Associe os coordenadores para os trechos que contrataram coordenação.</p>
          @for (trecho of coordenadoresPorTrecho; track trecho.tipoTrechoId) {
            <div class="coord-row">
              <span class="coord-trecho-label">{{ trecho.tipoTrechoDescricao }}</span>
              <mat-form-field appearance="outline" class="coord-select input-tg">
                <mat-label>Coordenadores</mat-label>
                <mat-select multiple [(ngModel)]="trecho.coordenadorIds">
                  @for (c of coordenadoresList; track c.id) {
                    <mat-option [value]="c.id">{{ c.nome }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          }
        </div>
      }
    </div>
  }

  <!-- Results -->
  @if (state === 'generated') {
    <div class="results-container">

      <!-- Coordenadores (aparece quando algum grupo tem serviço de coordenação) -->
      @if (temServicoCoorden) {
        <div class="coordenadores-section">
          <div class="section-heading">
            <mat-icon>manage_accounts</mat-icon>
            <span>Coordenadores</span>
          </div>
          @for (trecho of coordenadoresPorTrecho; track trecho.tipoTrechoId) {
            <div class="coord-row">
              <span class="coord-trecho-label">{{ trecho.tipoTrechoDescricao }}</span>
              <mat-form-field appearance="outline" class="coord-select input-tg">
                <mat-label>Coordenadores</mat-label>
                <mat-select multiple [(ngModel)]="trecho.coordenadorIds">
                  @for (c of coordenadoresList; track c.id) {
                    <mat-option [value]="c.id">{{ c.nome }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          }
        </div>
      }

      <!-- Grupos -->
      <div class="grupos-section">
        <div class="section-heading">
          <span>Grupos</span>
          <span class="count-badge">{{ grupos.length }}</span>
          <span class="section-heading-spacer"></span>
          <button mat-button class="btn-tg btn-add-grupo"
            [disabled]="loading"
            (click)="adicionarGrupo()">
            <mat-icon>add</mat-icon>
            Novo Grupo
          </button>
        </div>

        <div class="grupos-scroll">
          @for (grupo of grupos; track $index) {
            <div class="grupo-card" [ngClass]="{ 'grupo-card-divergente': grupo.rotaDivergente }">
              <div class="grupo-header">
                <div class="grupo-meta">
                  <div class="grupo-veiculo-row">
                    <span class="grupo-veiculo">{{ grupo.tipoVeiculoDescricao }}</span>
                    <button class="btn-icon btn-alterar-veiculo"
                      [matTooltip]="'Alterar veículo'"
                      [disabled]="loading"
                      (click)="trocarVeiculo(grupo)">
                      <mat-icon>swap_vert</mat-icon>
                    </button>
                    <button class="btn-icon"
                      [matTooltip]="'Adicionar serviço adicional'"
                      [disabled]="loading || catalogoServicos.length === 0"
                      (click)="openServicoDialog(grupo)">
                      <mat-icon>add_task</mat-icon>
                    </button>
                    @for (srv of grupo.servicosAdicionais; track srv.servicoAdicionalId) {
                      <span class="badge-servico" [matTooltip]="srv.descricao">
                        {{ srv.descricao.length > 14 ? (srv.descricao | slice:0:14) + '…' : srv.descricao }}
                        @if (srv.quantidade > 1) { ×{{ srv.quantidade }} }
                        <button class="badge-servico-remove" (click)="removerServico(grupo, srv)">×</button>
                      </span>
                    }
                    @if (grupo.isDuplicado) {
                      <span class="badge-duplicado" [matTooltip]="'Baseado no item #' + grupo.itemPropostaOriginalId">duplicado</span>
                    }
                    @if (grupo.individual) {
                      <span class="badge-individual" [matTooltip]="grupo.motivoIndividual ?? 'Individual'">{{ grupo.motivoIndividual ?? 'Individual' }}</span>
                    }
                    @if (grupo.rotaDivergente) {
                      <span class="badge-divergente" [matTooltip]="grupo.motivoDivergencia ?? 'Rota divergente'">
                        <mat-icon>warning</mat-icon> rota divergente
                      </span>
                    }
                  </div>
                  <span class="grupo-info-text">
                    {{ grupo.data }} &bull; {{ grupo.horaInicio }} – {{ grupo.horaFinal }}
                    @if (grupo.voo) { &bull; <span class="grupo-voo">{{ grupo.voo }}</span> }
                  </span>
                  @if (grupo.rotaDivergente) {
                    <div class="rota-divergente-banner" [matTooltip]="grupo.motivoDivergencia ?? ''">
                      <mat-icon>info</mat-icon>
                      <span>
                        Veículo cotado para <strong>{{ grupo.origemDescricao }} → {{ grupo.destinoDescricao }}</strong>
                        @if (grupo.passageirosDivergentes > 0) {
                          &bull; {{ grupo.passageirosDivergentes }} passageiro{{ grupo.passageirosDivergentes > 1 ? 's' : '' }} fora da rota
                        }
                      </span>
                    </div>
                  }
                  @if (grupo.passageiros.length > 0 && (agruparPorOrigem || agruparPorDestino)) {
                    <span class="grupo-endereco-row">
                      @if (agruparPorOrigem) {
                        <span class="grupo-endereco-item">
                          <mat-icon class="grupo-endereco-icon">trip_origin</mat-icon>
                          <span [innerHTML]="formatEndereco(grupo.passageiros[0], 'origem')"></span>
                        </span>
                      }
                      @if (agruparPorDestino) {
                        <span class="grupo-endereco-item">
                          <mat-icon class="grupo-endereco-icon">place</mat-icon>
                          <span [innerHTML]="formatEndereco(grupo.passageiros[0], 'destino')"></span>
                        </span>
                      }
                    </span>
                  }
                </div>
                <div class="grupo-header-actions">
                  <span class="pax-badge" [ngClass]="{ 'pax-full': grupo.passageiros.length >= grupo.capacidade }">
                    {{ grupo.passageiros.length }} / {{ grupo.capacidade }} PAX
                  </span>
                  <button class="btn-icon"
                    [matTooltip]="grupo.observacao ? grupo.observacao : 'Adicionar observação'"
                    [disabled]="loading"
                    (click)="openObservacaoDialog(grupo)">
                    <mat-icon>{{ grupo.observacao ? 'speaker_notes' : 'note_add' }}</mat-icon>
                  </button>
                  <button class="btn-icon btn-danger"
                    matTooltip="Remover grupo"
                    [disabled]="loading"
                    (click)="removerGrupo(grupo)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </div>

              <div class="passageiros-list">
                @for (passageiro of grupo.passageiros; track passageiro.id) {
                  <div class="passageiro-row">

                    <div class="passageiro-info">
                      @if (passageiro.speaker) {
                        <mat-icon class="speaker-icon" matTooltip="Speaker">record_voice_over</mat-icon>
                      }
                      @if (passageiro.multiploTrecho) {
                        <mat-icon class="flag-icon flag-multiplo" matTooltip="Múltiplo trecho">alt_route</mat-icon>
                      }
                      @if (passageiro.repetida) {
                        <mat-icon class="flag-icon flag-repetida" matTooltip="Passageiro duplicado">content_copy</mat-icon>
                      }
                      <span class="passageiro-nome">{{ passageiro.nome }}</span>
                      <span class="passageiro-hora">{{ passageiro.hora }}</span>
                    </div>

                    <div class="passageiro-actions">
                      <button class="btn-icon"
                        [matTooltip]="'Mover para outro grupo'"
                        [disabled]="grupos.length <= 1 || loading"
                        (click)="openMoverDialog(grupo, passageiro)">
                        <mat-icon>swap_horiz</mat-icon>
                      </button>
                      <button class="btn-icon btn-danger"
                        [matTooltip]="'Remover do grupo'"
                        [disabled]="loading"
                        (click)="onRemove(grupo, passageiro)">
                        <mat-icon>person_remove</mat-icon>
                      </button>
                    </div>

                  </div>
                }

                @if (grupo.passageiros.length === 0) {
                  <div class="empty-group-msg">Sem passageiros neste grupo</div>
                }
              </div>
            </div>
          }

          @if (grupos.length === 0) {
            <div class="empty-state">
              <mat-icon>inbox</mat-icon>
              <p>Nenhum grupo foi gerado.</p>
            </div>
          }
        </div>
      </div>

      <!-- Sem correspondência -->
      <div class="sem-correspondencia-section">
        <div class="section-heading">
          <span>Sem Correspondência</span>
          <span class="count-badge count-badge-warn">{{ semCorrespondencia.length }}</span>
        </div>

        <div class="sc-scroll">
          @for (p of semCorrespondencia; track p.id) {
            <div class="sc-row">
              <div class="passageiro-info">
                @if (p.multiploTrecho) {
                  <mat-icon class="flag-icon flag-multiplo" matTooltip="Múltiplo trecho">alt_route</mat-icon>
                }
                @if (p.repetida) {
                  <mat-icon class="flag-icon flag-repetida" matTooltip="Passageiro duplicado">content_copy</mat-icon>
                }
                <span class="passageiro-nome">{{ p.nome }}</span>
                <span class="passageiro-hora">{{ p.hora }}</span>
              </div>
              @if (p.motivo) {
                <span class="motivo-text">{{ p.motivo }}</span>
              }
              <div class="sc-actions">
                @if (!p.speaker) {
                  <button class="btn-icon"
                    [matTooltip]="'Mover para um grupo'"
                    [disabled]="grupos.length === 0 || loading"
                    (click)="moverPassageiroSemCorrespondencia(p)">
                    <mat-icon>group_add</mat-icon>
                  </button>
                }
                @if (p.sugerirCriarItemProposta) {
                  <button mat-button class="btn-tg btn-criar-item" (click)="criarItemProposta(p)">
                    <mat-icon>add_circle_outline</mat-icon>
                    Criar Item
                  </button>
                }
              </div>
            </div>
          }

          @if (semCorrespondencia.length === 0) {
            <div class="empty-state">
              <mat-icon>check_circle_outline</mat-icon>
              <p>Todos os passageiros foram agrupados.</p>
            </div>
          }
        </div>
      </div>

    </div>
  }

</div>
